export enum PermissionScope {
  GLOBAL = 1,
  CLIENT = 2,
  LOCATION = 3,
  PROPERTY = 5,
  USER_GROUP = 4,
  REPORT_TOPIC = 6,
}
